import { render } from "./ReservationTable.vue?vue&type=template&id=065835c9&scoped=true&ts=true"
import script from "./ReservationTable.vue?vue&type=script&lang=ts"
export * from "./ReservationTable.vue?vue&type=script&lang=ts"

import "./ReservationTable.vue?vue&type=style&index=0&id=065835c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065835c9"]])

export default __exports__